import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/faq/page.tsx");
